// Module
var code = "<react-component name=\"ArchivedSequencesList\"></react-component>\n";
// Exports
module.exports = code;